import React, { useState } from "react";
import { classnames, Subnav } from "@culturehq/components";
import { Trans } from "app/utils";
import ExclamationIcon from "components/common/ExclamationIcon";
import { Context, Mode, ScreenProps } from "./AnimationTypes";
import AnimationList from "./AnimationList";

import styles from "./animation.module.scss";

const AnimationScreen = ({
  context,
  preview,
  activeElement
}: ScreenProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const showAnimationList = context && preview && activeElement;
  const showTransitionTab = context !== Context.Subtitle;
  const modes = {
    0: Mode.Enter,
    1: Mode.Exit,
    2: Mode.Transition
  };
  const mode = modes[tabIndex as keyof typeof modes] as Mode;

  const tabs = [
    <Subnav.Item>
      <Trans>Enter</Trans>
    </Subnav.Item>,
    <Subnav.Item>
      <Trans>Exit</Trans>
    </Subnav.Item>
  ];

  if (showTransitionTab) {
    tabs.push(
      <Subnav.Item>
        <Trans>Transition</Trans>
      </Subnav.Item>
    );
  }

  return (
    <div className={classnames(styles.Screen, "Animations")}>
      <Subnav className={styles.Tabs} onChange={setTabIndex}>
        {tabs}
      </Subnav>
      {tabIndex === 2 && (
        <div className="DisclaimerContainer">
          <p><ExclamationIcon className="DisclaimerContainer-Text--Icon" /></p>
          <p className="DisclaimerContainer-Text">
            <Trans>
              This will be applied between the current element selected and the previous element
            </Trans>
          </p>
        </div>
      )}
      {showAnimationList && (
        <AnimationList
          mode={mode}
          context={context}
          preview={preview}
          activeElement={activeElement}
        />
      )}
    </div>
  );
};

export default AnimationScreen;
